import { render } from "./BlManyToManyComponentContainer.vue?vue&type=template&id=eb1a4cde"
import script from "./BlManyToManyComponentContainer.vue?vue&type=script&lang=js"
export * from "./BlManyToManyComponentContainer.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/b45e941b-d1ac-4235-8dba-072c0c886010/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__